import {Bar} from 'vue-chartjs'
import i18n from "@/i18n";

export default {
    extends: Bar,
    data() {
        return {
            query: '',
            stop: false,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                showTooltips: false,
                showInlineValues: true,
                centeredInllineValues: true,
                scales: {
                    xAxes: [{
                        stacked: true,
                        categoryPercentage: 0.5,
                        barPercentage: 1
                    }],
                    yAxes: [{
                        stacked: true
                    }]
                }
            },
            delay: [],
            labels: []
        }
    },
    methods: {
        render() {
            this.renderChart({
                labels: this.labels,
                datasets: [
                    {
                        type: 'bar',
                        label: i18n.t("monitoring.ppDelayChart.delayPs"),
                        tooltipTemplate: 'ddd',
                        backgroundColor: 'orange',
                        data: this.delay,
                    }
                ]
            }, this.options);
        },
        init(data) {
            this.labels = [];
            this.delay = [];
            data.forEach(e => {
                this.labels.push(e.name);
                this.delay.push(Number.parseInt(e.delay));
            });
            this.render();
        }
    }
};